"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diff = exports.split = void 0;
var ace_1 = require("./ace");
var diff_1 = require("./diff");
exports.diff = diff_1.default;
var split_1 = require("./split");
exports.split = split_1.default;
exports.default = ace_1.default;
//# sourceMappingURL=index.js.map